<template>
    <div class="wrap-input" :class="customClass">

        <!-- <div class="label-wrapper">
            <label class="label col-4 px-0">{{label}}</label>

            <label class="error-text col-8 pr-3"
                v-show="!isFirstSave && !errorInfo.isValid && isShowErrorLbl">{{errorInfo.msg}}</label>
        </div> -->
        <div class="row">
            <div class="col-12 d-flex">
                <div class="form-group col-3 px-0">
                    <b-dropdown :text="textDay"
                        class="ddl-input"
                        variant="ddl-input"
                        menu-class="ddl-menu">
                        <b-dropdown-item v-for="(v,k) in dayList"
                                        :key="k"
                                        @click="selectDay(v)">
                            {{v.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="form-group col-5 px-1">
                    <b-dropdown :text="textMonth"
                        class="ddl-input"
                        variant="ddl-input"
                        menu-class="ddl-menu">
                        <b-dropdown-item v-for="(v,k) in monthList"
                                        :key="k"
                                        @click="selectMonth(v)">
                            {{v.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="form-group col-4 px-0">
                    <b-dropdown :text="textYear"
                        class="ddl-input"
                        variant="ddl-input"
                        menu-class="ddl-menu">
                        <b-dropdown-item v-for="(v,k) in yearList"
                                        :key="k"
                                        @click="selectYear(v)">
                            {{v.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
        <div class="bi-lbl-error"
            v-if="isShowErrorLbl"
            v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import moment from "moment";
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {Object} inputLbl (required) Text for component.
 * @property {Boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {String} addClass (optional) Add css class.
 * @property {Array} itemList (required) item list in dropdown. example : [{ value: '1', text: 'a'}]
 */
export default {
    name: "Dropdown",
    props: {
        //v-model
        value: String,
        //props
        inputLbl: Object,
        lbl: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        addClass: String,
        itemList: Array,
        isShowLabel: Boolean,
        dayList: Array,
        monthList: Array,
        yearList: Array,

        setDay: Object,
        setMonth: Object,
        setYear: Object,

    },
    data: function() {
        return {
            label: '',
            content: this.value,
            customClass: '',

            textValueDropdown: '',
            dropdownList: [],

            textDay: 'Day',
            textMonth: 'Month',
            textYear: 'Year',

            tracking: new TrackingService(this),
        };
    },
    mounted: function() {
        this.label = this.inputLbl.name || 'Label';
        this.customClass = this.addClass || '';
        this.dropdownList = this.itemList;
        this.textValueDropdown = this.inputLbl.defaultText;

        this.textDay = this.lbl.day;
        this.textMonth = this.lbl.month;
        this.textYear = this.lbl.year;

        this.daySelect = this.lbl.day;
        this.monthSelect = this.lbl.month;
        this.yearSelect = this.lbl.year;
        // if (!Util.isEmptyStr(this.setDay)) {
        //     this.selectDay(this.setDay);
        // }
        // if (!Util.isEmptyStr(this.setMonth)) {
        //     this.selectMonth(this.setMonth);
        // }
        // if (!Util.isEmptyStr(this.setYear)) {
        //     this.selectYear(this.setYear);
        // }

        this.initialDefaultValue();
        this.validateInput();
    },
    methods: {
        initialDefaultValue: function() {
            if (Util.isEmptyStr(this.value)) {
                return;
            }

            for (var i of this.dropdownList) {
                if (i.value == this.value) {
                    this.onChange(i);
                    break;
                }
            }
        },
        validateInput: function() {
            if (this.inputLbl.required) {
                if (Util.isEmptyStr(this.yearSelect) ||
                    Util.isEmptyStr(this.monthSelect ||
                    Util.isEmptyStr(this.daySelect)))
                {

                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required;
                    return;
                }
            }
            // if(!this.inputLbl) return;
            // //Set default.
            // this.errorInfo.isValid = true;
            // this.errorInfo.msg = '';
            // //Required
            // if(this.inputLbl.required && Util.isEmptyStr(this.content)) {
            //     this.errorInfo.isValid = false;
            //     this.errorInfo.msg = this.inputLbl.required;
            //     return;
            // }
        },
        validate: function () {
            if (this.inputLbl.required) {
                if (Util.isEmptyStr(this.yearSelect) ||
                    Util.isEmptyStr(this.monthSelect) ||
                    Util.isEmptyStr(this.daySelect))
                {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required;
                    return;
                }
            }
            // const today = new Date();
            // const birthDate = new Date(this.yearSelect+"-"+this.monthSelect+"-"+this.daySelect);
            // let age = today.getFullYear() - birthDate.getFullYear();
            // console.log(birthDate);
            // const monthDiff = today.getMonth() - birthDate.getMonth();
            // if (age == 20) {
            //     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            //         this.errorInfo.isValid = false;
            //         this.errorInfo.msg = this.inputLbl.age_consent;
            //         return;
            //     }
            // }

            // console.log(age)
            if (!this.checkEmptyDate()) {
                return
            }

            //var time = DatetimeHelper.isDatetimeValid(this.yearSelect, this.monthSelect, this.daySelect);
            // console.log(`${this.yearSelect}, ${this.monthSelect}, ${this.daySelect}`);
            if (this.daySelect != this.lbl.day) {
                if (!DatetimeHelper.isDatetimeValid(this.yearSelect, this.monthSelect, this.daySelect)) {


                    var date = this.yearSelect + "-" + this.monthSelect + "-15";
                    var dateselect = {
                        value: moment(date, 'YYYY-MM-DD').endOf('month').format('D'),
                        text: moment(date, 'YYYY-MM-DD').endOf('month').format('D')
                        };
                    this.selectDay(dateselect);

                    // this.errorInfo.isValid = false;
                    // this.errorInfo.msg = this.inputLbl.invalid;
                    console.log(1);
                    return;
                }
            }


            console.log(2);

            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';

        },
        checkEmptyDate: function () {
            // && this.daySelect != this.lbl.day
            // && this.monthSelect != this.lbl.month
            // && this.yearSelect != this.lbl.year
            if (this.daySelect == this.lbl.day && this.monthSelect == this.lbl.month && this.yearSelect == this.lbl.year) {
                return true
            } else {
                if (this.daySelect == this.lbl.day) {
                    if (this.monthSelect != this.lbl.month || this.yearSelect != this.lbl.year) {
                        this.errorInfo.isValid = false;
                        this.errorInfo.msg = this.inputLbl.required_all;
                        return false
                    }
                }
                if (this.monthSelect == this.lbl.month) {
                    if (this.daySelect != this.lbl.day || this.yearSelect != this.lbl.year) {
                        this.errorInfo.isValid = false;
                        this.errorInfo.msg = this.inputLbl.required_all;
                        return false
                    }
                }
                 if (this.yearSelect == this.lbl.year) {
                    if (this.daySelect != this.lbl.day || this.monthSelect != this.lbl.month) {
                        this.errorInfo.isValid = false;
                        this.errorInfo.msg = this.inputLbl.required_all;
                        return false
                    }
                }
            }

            if (this.daySelect) {
                if (!this.yearSelect || !this.monthSelect) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required_all;
                    return false;
                }
            }
            if (this.monthSelect) {
                if (!this.yearSelect || !this.daySelect) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required_all;
                    return false;
                }
            }
            if (this.yearSelect) {
                if (!this.monthSelect || !this.daySelect) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.required_all;
                    return false;
                }
            }
            return true
        },
        onChange: function(selected) {
            this.content = selected.value;
            this.textValueDropdown = selected.text;

            this.validateInput();
            this.$emit('input', selected.value);
        },
        selectDay: function(value) {
            // console.log(value);
            this.tracking.event("regis_user_info", "click_birthday_day_box");
            this.daySelect = value.value;
            this.textDay = value.text+ "";
            this.valueChange();
        },
        selectMonth: function(value) {
            this.tracking.event("regis_user_info", "click_birthday_month_box");
            this.monthSelect = value.value;
            this.textMonth = value.text + "";
            this.valueChange();
        },
        selectYear: function(value) {
            this.tracking.event("regis_user_info", "click_birthday_year_box");
            this.yearSelect = value.text;
            this.textYear = value.text + "";
            this.valueChange();
        },
        valueChange: function() {
            this.validate();
            //TODO emit input
            var data = {
                day: this.daySelect,
                month: this.monthSelect,
                year: this.yearSelect,
            };
            if (this.daySelect == this.lbl.day && this.monthSelect == this.lbl.month && this.yearSelect == this.lbl.year) {
                data = null
            }
            this.$emit('onChange', data);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/component/baseinput.scss";

    .bi-lbl-error {
        width: 100%;
        margin-bottom: 3px;
        color: #EB1456;
        font-size: $bi_error_font_size;
        text-align: right;
    }
    // $url-dropdown-icon: url('../../assets/other/icon_dropdown.png');
    // @import "@/style/base/base.scss";
    // @import "@/style/InputCustom/Dropdown.scss";
    ::-webkit-scrollbar-thumb {
        //background: $orange;
        overflow-y: scroll;
        border-radius: 10px
    }
    ::-webkit-scrollbar {
        width: 5px;

    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(238, 238, 238);
        border-radius: 10px;
    }

    .wrap-input{
        padding-top: 10px;
        margin-top: 0;
        label{
            color: #000;
            margin-bottom: 5px;
            font-family: 'Bold';
        }
    }


</style>
<style lang="scss">
    // @import "@/style/input/Text.scss";


</style>
